export const pageIdLogObject = {
    pageMatch: {
        path: null,
    },
    lastTab: null,
};